import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Grid } from '@mui/material';
import { FC, useCallback } from 'react';

import { InstrumentsAutocompleteReferenceInput } from '@sh4res/bo-common/components/InstrumentsAutocompleteReferenceInput';

interface Props {
  year: number;
  isLastRow: boolean;
  index: number;
  onRemove: (index: number) => void;
}

export const B2bInvestorProfileSicavGridRow: FC<Props> = ({ isLastRow, year, index, onRemove }) => {
  const handleRemove = useCallback(() => {
    onRemove(index);
  }, [index, onRemove]);

  return (
    <Grid
      item
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px #EBEBEB solid',
        backgroundColor: isLastRow ? '#F7F7F7' : 'white',
        padding: '5px 10px 10px 10px',
      }}>
      <Grid item xs={4}>
        <span>{isLastRow ? `> ${year}` : year}</span>
      </Grid>
      <Grid item xs={8}>
        <InstrumentsAutocompleteReferenceInput
          source={`sicav_grid.${index}.instrument_id` as const}
          filters={{ is_plan_universe_eligible: true }}
          label="resources.bo_common.b2b.investor_profile.create.sicav_grid_configuration.instrument_placeholder"
          isRequired
          shouldUnregister
          testId="BoExternalB2bInvestorProfileSicavGridRow"
        />
      </Grid>
      {isLastRow && index !== 0 && (
        <div style={{ position: 'absolute', right: 24, cursor: 'pointer' }}>
          <DeleteOutlinedIcon onClick={handleRemove} sx={{ fontSize: 24 }} color="action" />
        </div>
      )}
    </Grid>
  );
};
